// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__XZARQ","rightAdornment":"Header_rightAdornment__1NO2e"};